/** Shared shapes for the per-locale tile pickers. */

export type TileLocale = "ar" | "en";
export type TileFiles = Record<TileLocale, File | null>;
export type TileSizes = Record<TileLocale, { w: number; h: number } | null>;

/** The six migrated tiles are this size; one that differs sits out of line. */
export const TILE_SIZE = { w: 339, h: 340 };

export const EMPTY_TILES: TileFiles = { ar: null, en: null };
export const EMPTY_SIZES: TileSizes = { ar: null, en: null };

/** Read a picked image's real dimensions before anything is sent. */
export function measureImage(
  file: File,
  done: (size: { w: number; h: number }) => void,
): void {
  const url = URL.createObjectURL(file);
  const img = new Image();
  img.onload = () => {
    done({ w: img.naturalWidth, h: img.naturalHeight });
    URL.revokeObjectURL(url);
  };
  img.onerror = () => URL.revokeObjectURL(url);
  img.src = url;
}
